import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	allTemplates: {
		id: 'blank-page-quick-actions.allTemplates',
		defaultMessage: 'All templates',
		description: 'The text for blank page quick actions all templates link',
	},
	moreElements: {
		id: 'blank-page-quick-actions.moreElements',
		defaultMessage: 'More elements',
		description: 'The text for blank page quick actions more elements link',
	},
	helperText: {
		id: 'blank-page-quick-actions.helperText',
		defaultMessage: 'Select an element to get started, or just type',
		description: 'The helper text for blank page quick actions',
	},
	brainstormName: {
		id: 'blank-page-quick-actions.brainstormName',
		defaultMessage: 'Brainstorm',
		description:
			'The text is shown as the label for the Brainstorm quick action item on a blank page, displayed in the list of content elements a user can insert when starting a new page.',
	},
	brainstormDescription: {
		id: 'blank-page-quick-actions.brainstormDescription',
		defaultMessage: 'Use Brainstorm to insert content',
		description:
			'The text is shown as a short description beneath the Brainstorm quick action item on a blank page, explaining to users what the Brainstorm action does when selected.',
	},
	brainstormAltText: {
		id: 'blank-page-quick-actions.brainstormAltText',
		defaultMessage: 'Use Brainstorm to insert content',
		description:
			'The text is used as the alt attribute for the image representing the Brainstorm quick action item on a blank page, providing a text description for screen readers and when the image cannot be displayed.',
	},
	tableName: {
		id: 'blank-page-quick-actions.tableName',
		defaultMessage: 'Table',
		description:
			'The text is shown as the label for the Table quick action item on a blank page, displayed in the list of content elements a user can insert when starting a new page.',
	},
	tableDescription: {
		id: 'blank-page-quick-actions.tableDescription',
		defaultMessage: 'Insert a table',
		description:
			'The text is shown as a short description beneath the Table quick action item on a blank page, explaining to users that selecting it will insert a table into the page.',
	},
	tableAltText: {
		id: 'blank-page-quick-actions.tableAltText',
		defaultMessage: 'Insert a table',
		description:
			'The text is used as the alt attribute for the image representing the Table quick action item on a blank page, providing a text description for screen readers and when the image cannot be displayed.',
	},
	infoPanelName: {
		id: 'blank-page-quick-actions.infoPanelName',
		defaultMessage: 'Info panel',
		description:
			'The text is shown as the label for the Info panel quick action item on a blank page, displayed in the list of content elements a user can insert when starting a new page.',
	},
	infoPanelDescription: {
		id: 'blank-page-quick-actions.infoPanelDescription',
		defaultMessage: 'Highlight information in a colored panel',
		description:
			'The text is shown as a short description beneath the Info panel quick action item on a blank page, explaining that selecting it will insert a colored panel to highlight important information.',
	},
	infoPanelAltText: {
		id: 'blank-page-quick-actions.infoPanelAltText',
		defaultMessage: 'Insert an info panel to highlight information in a colored panel',
		description:
			'The text is used as the alt attribute for the image representing the Info panel quick action item on a blank page, providing a text description for screen readers and when the image cannot be displayed.',
	},
	tableOfContentsName: {
		id: 'blank-page-quick-actions.tableOfContentsName',
		defaultMessage: 'Table of contents',
		description:
			'The text is shown as the label for the Table of contents quick action item on a blank page, displayed in the list of content elements a user can insert when starting a new page.',
	},
	tableOfContentsDescription: {
		id: 'blank-page-quick-actions.tableOfContentsDescription',
		defaultMessage: 'Create a table of contents based on your content’s headings',
		description:
			'The text is shown as a short description beneath the Table of contents quick action item on a blank page, explaining that it generates a navigable table of contents based on the heading structure of the page.',
	},
	tableOfContentsAltText: {
		id: 'blank-page-quick-actions.tableOfContentsAltText',
		defaultMessage: 'Insert a table of contents',
		description:
			'The text is used as the alt attribute for the image representing the Table of contents quick action item on a blank page, providing a text description for screen readers and when the image cannot be displayed.',
	},
	tableOfContentsTitle: {
		id: 'blank-page-quick-actions.tableOfContentsTitle',
		defaultMessage: 'Table of Contents',
		description: 'Title for table of contents macro for macro panel',
	},
	templateLoadError: {
		id: 'blank-page-quick-actions.templateLoadError',
		defaultMessage:
			'We’re having trouble loading suggested templates - refresh, or go to <button>all templates.</button>',
		description: 'Error message shown when we cannot load suggested templates',
	},
	templateSuccessFlagTitle: {
		id: 'blank-page-quick-actions.templateSuccessFlagTitle',
		defaultMessage: '“{templateName}” template chosen',
		description: 'Title for success flag shown when a user successfully chooses a template.',
	},
	templateSuccessFlagDescription: {
		id: 'blank-page-quick-actions.templateSuccessFlagDescription',
		defaultMessage: 'You can change templates any time.',
		description: 'Description for success flag shown when a user successfully chooses a template.',
	},
	templateSuccessFlagBrowserOtherTemplatesLink: {
		id: 'blank-page-quick-actions.templateSuccessFlagBrowserOtherTemplatesLink',
		defaultMessage: 'Browse other templates',
		description: 'Description for success flag link to browse other templates.',
	},
	templateSuccessFlagClearEditorLink: {
		id: 'blank-page-quick-actions.templateSuccessFlagClearEditorLink',
		defaultMessage: 'Clear all',
		description: 'Description for success flag link to clear editor contents.',
	},
	revampedBpqaTemplatePrefix: {
		id: 'blank-page-quick-actions.revampedBpqaTemplatePrefix',
		defaultMessage: 'For you:',
		description: 'Text shown before the list of recommended templates.',
	},
	createWithRovo: {
		id: 'blank-page-quick-actions.createWithRovo',
		defaultMessage: 'Create with Rovo',
		description:
			'The text is shown on a button displayed on a blank page in the editor quick actions area. When clicked, it opens the Rovo AI assistant to help the user generate content for their new page.',
	},
	chooseATemplate: {
		id: 'blank-page-quick-actions.chooseATemplate',
		defaultMessage: 'Choose a template',
		description:
			'The text is shown on a button displayed on a blank page in the editor quick actions area. When clicked, it opens the template gallery so the user can select a page template to start with.',
	},
	addElements: {
		id: 'blank-page-quick-actions.addElements',
		defaultMessage: 'Add elements',
		description:
			'The text is shown on a button displayed on a blank page in the editor quick actions area. When clicked, it opens a menu allowing the user to browse and insert various content elements (e.g. tables, panels, macros) into the page.',
	},
	import: {
		id: 'blank-page-quick-actions.import',
		defaultMessage: 'Import',
		description:
			'The text is shown on a button displayed on a blank page in the editor quick actions area. When clicked, it initiates an import flow that allows the user to import content from an external source into the page.',
	},
	clickAnywhereToDismiss: {
		id: 'blank-page-quick-actions.clickAnywhereToDismiss',
		defaultMessage: 'Click anywhere to dismiss',
		description:
			'Text shown below the Create with Rovo experience to inform users they can click anywhere to dismiss it',
	},
	templates: {
		id: 'blank-page-quick-actions.templates',
		defaultMessage: 'Templates',
		description:
			'Label for the button in the Create with Rovo smart prompts row that opens the editor templates panel.',
	},
});
